import DuckEntity from './DuckEntity';

const entity = new DuckEntity('customers');

export {entity};
